<template>
    <sa-page-layout :showModalLoading="showModalLoading" :btnRefreshVisible="true" :btnNewVisible="false"
        :pathResource="pathResource" @refresh="onRefresh" :linkedit="linkedit">
        <template slot="table-body">
            <external-prenotazione-presa-in-carico-component ref="cmpExternalPrenotazionePresaInCaricoComponent"
                @beforeLoadData="onBeforeLoadDataExternalPrenotazionePresaInCaricoComponent"
                @afterLoadData="onAfterLoadDataExternalPrenotazionePresaInCaricoComponent" />
        </template>
    </sa-page-layout>
</template>
<script>
import SaPageLayout from "../../../template/sa/components/layout/contents/SaPageLayout.vue";
import ExternalPrenotazionePresaInCaricoComponent from "../components/ExternalePrenotazioniListPresaInCaricoComponent.vue";
export default {
    components: { SaPageLayout, ExternalPrenotazionePresaInCaricoComponent },
    computed: {
        rows() {
            return this.items.length;
        },
    },
    data() {
        return {
            perPage: 10,
            currentPage: 1,
            filter: null,
            id: "-1",
            pathResource: "/flussi",
            linkedit: "/struttura",
            filtro: {},
            filterOn: [],
            showModalLoading: false,
            fields: [
                {
                    label: "Tipo",
                    key: "tipo",
                    sortable: false,
                    // thStyle: "width: 0.25rem",
                },
                {
                    label: "Mese Riferimento",
                    key: "meseRiferimento",
                    sortable: false,
                    // thStyle: "width: 0.25rem",
                },
                {
                    label: "Anno Riferimento",
                    key: "annoRiferimento",
                    sortable: false,
                    // thStyle: "width: 0.25rem",
                },
                { class: "sa-table-column-action-double", key: "actions", label: "" },
            ],
            items: [
                { tipo: "FILE H", meseRiferimento: "MARZO", annoRiferimento: "2025" },
                { tipo: "FILE H", meseRiferimento: "APRILE", annoRiferimento: "2025" },
            ],
        };
    },
    mounted: function () {
        let me = this;
        me.loadData();
    },
    methods: {
        onBeforeLoadData() {
            let me = this;
            me.showModalLoading = true;
        },
        onAfterLoadData() {
            let me = this;
            me.showModalLoading = false;
        },
        loadData() {
            let me = this;
            me.$refs.cmpExternalPrenotazionePresaInCaricoComponent.init();
        },
        onRefresh() {
            let me = this;
            me.loadData();
        },
        // onClickNuovo() {
        //     let me = this;
        //     me.$refs.cmpFlussiModalEdit.show();
        // },
        onAfterSave() {
            let me = this;
            me.loadData();
        },
        onTabInput(tab) {
            switch (tab) {
                case 0:
                    this.$refs.cmpExternalPrenotazioniList.init();
                    break;
                case 1:
                    this.$refs.cmpExternalPrenotazionePresaInCaricoComponent.init();
                    break;

                default:
                    break;
            }
        },
        onBeforeLoadDataExternalPrenotazionePresaInCaricoComponent() {
            console.log("ok");
        },
        onAfterLoadDataExternalPrenotazionePresaInCaricoComponent() {
            console.log("ok");
        },
    },
};
</script>
